import * as React from 'react';
import Icon from './Icon';
import CtaButton from './CtaButton';

export default function VideoBanner(props) {
  const {
    title,
    html,
    links = [],
    video = null,
    poster = null,
    cta = '',
    url = '',
    target = '_blank',
  } = props;

  const videoRef = React.useRef(null);

  React.useEffect(() => {
    let timeOut;
    if (videoRef.current) {
      timeOut = setTimeout(() => {
        // Force load video and play it.
        videoRef.current.load();

        videoRef.current.play().catch(err => {
          console.warn("Autoplay prevented:", err);
        });
      }, 100);
    }

    return () => {
      if (timeOut) {
        clearTimeout(timeOut);
      }
    };
  }, []);

  return (
    <div className='nv-banner__inner'>
      <video muted playsInline autoPlay loop ref={videoRef} poster={poster}>
        <source src={video} type='video/mp4'/>
        Your browser does not support the video tag.
      </video>
      <div className="nv-banner__content">
        <div className="nv-banner__header" dangerouslySetInnerHTML={{__html: title}}></div>
        <div className="nv-banner__header" dangerouslySetInnerHTML={{__html: html}}></div>
        <CtaButton text={cta} url={url} target={target} />
        <div className="nv-banner__icons">
          {links.length > 0 && links.map(link => {
            return (
              <Icon
                key={link.url}
                url={link.url}
                platform={link.platform}
                target='_blank'
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
